import React from "react";

import type { StepId } from "@app/analytics/onboarding/types";

import CalendarStep from "./CalendarStep/CalendarStep";
import IntegrationsStep from "./IntegrationsStep";
import WorkspaceStep from "./WorkspaceStep";
import WrapUpStep from "./WrapUpStep";

export const COMPONENTS: {
  [key in Exclude<StepId, "account">]: React.ComponentType;
} = {
  workspace: WorkspaceStep,
  calendar: CalendarStep,
  integrations: IntegrationsStep,
  wrapUp: WrapUpStep,
};

export default COMPONENTS;
